/**
 * Created by mohameds on 11/7/19.
 */
import React from 'react'
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as AgencyMonitorAdminAction from "../../actions/AgencyMonitorAdminAction";
import MainDashboard from "../../components/agencyMonitor/MainDashboard";
import * as AuthAction from "../../actions/AuthAction";
import * as MonitorAction from "../../actions/AgencyMonitorPageAction";

const AgencyMonitorDashboard = (props) => (
  <React.Fragment>
    <MainDashboard {...props} />
  </React.Fragment>
);
function mapStateToProps(state) {
  return {
    agencyLocation: state.AgencyLocationReducer,
    agencyMonitor: state.AgencyMonitorReducer,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      AgencyLocation: bindActionCreators(AuthAction, dispatch),
      MonitorAdmin: bindActionCreators(AgencyMonitorAdminAction, dispatch),
      MonitorPage: bindActionCreators(MonitorAction, dispatch),
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AgencyMonitorDashboard);



// WEBPACK FOOTER //
// ./src/containers/AgencyMonitor/AgencyMoniorDashboard.js